// extracted by mini-css-extract-plugin
module.exports = {"payment":"styles_payment__2XnDF","description":"styles_description__kmfug","agreement":"styles_agreement__-0D5t"};